<div
  class="capsule-container inactive-capsule"
  [style.background]="isBW ? '#F5F5F5' : '#ffffff'"
  [style.color]="isBW ? '#3D3C3C' : '#2f6cf6'"
  (click)="triggerValue()"
>
  {{ label }}
</div>
